import React from 'react';

const ImageUpload = (props) => {

    return (
        <div className={`optimized__d-flex-class flex-grow-1 align-items-stretch ${props.stylesClass}`}>
            <div className={props.hasError ? "image-uploader__container--error mx-2" : "image-uploader__container mx-2"}>
            {
                !!props.image ? (
                    <>
                        <span className="image-uploader__close-btn" onClick={props.onCloseClicked}><i className="simple-icon-close" id={`remove_${props.identifier}`}></i></span>
                        <img className="img-fluid" src={URL.createObjectURL(props.image)}/>
                    </>
                ) : (
                    <label htmlFor={props.identifier} className="image-uplader__empty-label flex-grow-1">
                        {props.placeholder || "درج تصویر"}
                    </label>
                )
            }            
                <input id={props.identifier} type="file" className="d-none" ref={props.inputRefrence} onChange={props.onFileChanged}/>
            </div>
        </div>
    );
}

ImageUpload.defaultProps = {
    hasError: false
}

export default ImageUpload;